import React from 'react';
import PropTypes from 'prop-types';

import { POSITION_ABBREVIATIONS } from '../../../config/positions';
import { useSeasonYear, useCompetitionProvider } from '../hooks';
import { getPlayerHeadshotSize } from 'widgets/statspro/js/components/common/utils';
import { StatsTableRowHeader } from 'widgets/statspro/js/components/common/stats-table/StatsTableRowHeader';

export const StatsLeadersPlayerCell = ({ player, rank, ...cellProps }) => {
    const seasonYear = useSeasonYear();
    const competitionProvider = useCompetitionProvider();

    const onCellRefChange = (ref) => {
        if (typeof competitionProvider !== 'undefined') {
            new PULSE.app.PlayerHeadshot(ref, competitionProvider);
        }
    };

    return (
        <StatsTableRowHeader
            cellProps={cellProps}
            onCellRefChange={onCellRefChange}
            className="u-text-left u-bold"
        >
            <div className="stats-leaders-table-player">
                <div
                    className="stats-leaders-table-player__headshot u-hide-until-desktop"
                    data-widget="player-headshot"
                >
                    <div
                        className="js-player-image"
                        data-player={player.playerId.replace('CD_I', '')}
                        data-picture-classes=""
                        data-wrapper-class=""
                        data-size={getPlayerHeadshotSize(seasonYear)}
                        data-picture-in-view="false"
                        data-year={seasonYear}
                    />
                </div>
                <span className="stats-leaders-table-player__rank u-hide-from-desktop">
                    {rank}
                </span>
                <a
                    href={PULSE.app.common.url.getPlayerProfileURL(
                        player.playerId
                    )}
                    className="stats-leaders-table-player__name"
                >
                    {`${player.givenName} ${player.surname}`}
                </a>
                <span className="stats-leaders-table-player__position">
                    <span className="stats-leaders-table-position-badge u-hide-until-desktop">
                        {POSITION_ABBREVIATIONS[player.position]}
                    </span>
                </span>
            </div>
        </StatsTableRowHeader>
    );
};

StatsLeadersPlayerCell.propTypes = {
    player: PropTypes.object.isRequired,
    rank: PropTypes.number.isRequired
};
